export enum JOB_MODULES_SORTS {
  STARTED_AT_DESC = "-started_at",
}
